import React from 'react';
import { createPortal } from 'react-dom';
import Base from './Base';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DateObject from "react-date-object";

export default class NewTaskModal extends Base {
    constructor(props) {
        super(props);
        const startDate = props.start ? new DateObject({
            date: new Date(props.start),
            calendar: persian,
            locale: persian_fa
        }) : null;

        this.state = {
            lockScreen: 0,
            users: [],
            contracts: [],
            // جایگزین: تکالیف قرارداد (به‌جای خدمات)
            contractTemplates: [],
            selectedTemplateIds: [],
            // جستجوی قرارداد
            contractSearchTerm: '',
            filteredContracts: [],
            contractDropdownOpen: false,
            dropdownPosition: { top: 0, left: 0, width: 0 },
            record: {
                id: 0,
                title: '',
                description: '',
                dueDate: startDate,
                startDate: startDate,
                assignedToUserId: '',
                supervisorUserId: '',
                priority: 1,
                status: 1,
                taskCategory: 1,
                contractId: null
            }
        };
        this.contractInputRef = React.createRef();
    }

    componentDidMount() {
        this.httpPost('api/v1/task/get', { id: 0 })
            .then(data => {
                if (data.status === 1) {
                    const contracts = data.contracts || [];
                    this.setState({
                        users: data.users || [],
                        contracts: contracts,
                        filteredContracts: contracts
                    });
                }
            });
    }

    handleChange(field, value) {
        this.setState(prevState => ({
            record: { ...prevState.record, [field]: value }
        }));
    }

    openContractDropdown = () => {
        if (this.contractInputRef.current) {
            const rect = this.contractInputRef.current.getBoundingClientRect();
            this.setState({
                contractDropdownOpen: true,
                dropdownPosition: {
                    top: rect.bottom + window.scrollY,
                    left: rect.left + window.scrollX,
                    width: rect.width
                }
            });
        }
    };

    selectContract = (contract) => {
        this.handleChange('contractId', contract.id);
        this.setState({
            contractSearchTerm: contract.title,
            contractDropdownOpen: false
        });
        this.handleChange('title', `وظیفه برای ${contract.title}`);
        // به‌جای خدمات، تکالیف قانونی مرتبط با خدمات این قرارداد را دریافت کن
        this.fetchContractTemplates(contract.id);
    };

    handleContractSearch = (e) => {
        const term = e.target.value;
        const filtered = this.state.contracts.filter(c =>
            c.title.toLowerCase().includes(term.toLowerCase())
        );
        this.setState({
            contractSearchTerm: term,
            filteredContracts: filtered,
            contractDropdownOpen: true
        });
    };

    fetchContractTemplates = (contractId) => {
        this.httpPost('api/v1/legalobligation/templates-by-contract', { contractId })
            .then(data => {
                if (data.status === 1) {
                    const templates = data.templates || [];
                    this.setState({ contractTemplates: templates, selectedTemplateIds: [] }, () => {
                        this.rebuildTitle();
                    });
                    // اطلاعات قرارداد را برای توضیحات دریافت کن
                    this.httpPost('api/v1/contract/get', { id: contractId })
                        .then(res => {
                            if (res.status === 1) {
                                const c = res.record;
                                const info = `🔹 شماره قرارداد: ${c.contractNumber}\n📅 بازه: ${c.startDate || '---'} تا ${c.endDate || '---'}`;
                                this.handleChange('description', info);
                            }
                        });
                }
            });
    };

    toggleTemplate = (templateId) => {
        this.setState(prevState => {
            const isSelected = prevState.selectedTemplateIds.includes(templateId);
            const newSelectedIds = isSelected
                ? prevState.selectedTemplateIds.filter(id => id !== templateId)
                : [...prevState.selectedTemplateIds, templateId];
            return { selectedTemplateIds: newSelectedIds };
        }, () => this.rebuildTitle());
    };

    rebuildTitle = () => {
        const { contractTemplates, selectedTemplateIds, record } = this.state;
        if (!record.contractId) return;
        const selectedTitles = contractTemplates
            .filter(t => selectedTemplateIds.includes(t.id))
            .map(t => t.title);
        const contractNumber = record.title.includes('-')
            ? record.title.split('-').pop()?.trim()
            : '';
        let newTitle = selectedTitles.length > 0
            ? selectedTitles.join('، ') + ' - وظیفه جدید'
            : `وظیفه برای قرارداد` + (contractNumber ? ` ${contractNumber}` : '');
        this.handleChange('title', newTitle);
    };

    toISOString(dateObj) {
        if (!dateObj) return '';
        return dateObj.toDate().toISOString().slice(0, 16);
    }

    async save(e) {
        e.preventDefault();
        if (!this.state.record.title.trim()) {
            this.showErorrMessage('عنوان وظیفه الزامی است');
            return;
        }
        const recordToSend = {
            ...this.state.record,
            dueDate: this.toISOString(this.state.record.dueDate),
            startDate: this.toISOString(this.state.record.startDate)
        };
        this.setState({ lockScreen: 1 });
        this.httpPost('api/v1/task/save', recordToSend)
            .then(data => {
                this.setState({ lockScreen: 0 });
                if (data.status === 1) {
                    this.showSuccessMessage('وظیفه با موفقیت ایجاد شد');
                    this.props.onSaved();
                } else {
                    this.showErorrMessage(data.message);
                }
            });
    }

    render() {
        const { show, onClose } = this.props;
        const {
            record, users, lockScreen,
            contractTemplates, selectedTemplateIds,
            contractSearchTerm, contractDropdownOpen,
            filteredContracts, dropdownPosition
        } = this.state;
        if (!show) return null;

        return (
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">ایجاد وظیفه جدید</h5>
                            <button type="button" className="close" onClick={onClose}>&times;</button>
                        </div>
                        <form onSubmit={e => this.save(e)}>
                            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                <div className="row g-3">
                                    {/* عنوان */}
                                    <div className="col-12">
                                        <label className="form-label">عنوان <span className="text-danger">*</span></label>
                                        <input className="form-control" value={record.title}
                                            onChange={e => this.handleChange('title', e.target.value)} />
                                    </div>
                                    {/* تاریخ سررسید */}
                                    <div className="col-md-6">
                                        <label className="form-label">تاریخ سررسید</label>
                                        <DatePicker calendar={persian} locale={persian_fa}
                                            value={record.dueDate} onChange={date => this.handleChange('dueDate', date)}
                                            format="YYYY/MM/DD HH:mm" plugins={[<TimePicker position="bottom" />]} inputClass="form-control" />
                                    </div>
                                    {/* نوع وظیفه */}
                                    <div className="col-md-6">
                                        <label className="form-label">نوع وظیفه</label>
                                        <select className="form-select" value={record.taskCategory}
                                            onChange={e => this.handleChange('taskCategory', parseInt(e.target.value))}>
                                            <option value="1">داخلی</option>
                                            <option value="2">قراردادی</option>
                                        </select>
                                    </div>

                                    {/* انتخاب قرارداد (Searchable) */}
                                    {record.taskCategory === 2 && (
                                        <div className="col-md-6">
                                            <label className="form-label">قرارداد</label>
                                            <div>
                                                <input
                                                    ref={this.contractInputRef}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="جستجوی قرارداد..."
                                                    value={contractSearchTerm}
                                                    onFocus={this.openContractDropdown}
                                                    onChange={this.handleContractSearch}
                                                    onClick={this.openContractDropdown}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* ========== تکالیف قانونی قرارداد ========== */}
                                    {record.taskCategory === 2 && contractTemplates.length > 0 && (
                                        <div className="col-12">
                                            <label className="form-label">
                                                تکالیف مرتبط ({selectedTemplateIds.length}/{contractTemplates.length})
                                            </label>
                                            <div style={{
                                                maxHeight: '200px',
                                                overflowY: 'auto',
                                                border: '1px solid rgba(148, 163, 184, 0.3)',
                                                borderRadius: '12px',
                                                backgroundColor: 'rgba(15, 23, 42, 0.6)',
                                                backdropFilter: 'blur(8px)',
                                                padding: '10px'
                                            }}>
                                                <div className="row g-2">
                                                    {contractTemplates.map(tpl => {
                                                        const isSelected = selectedTemplateIds.includes(tpl.id);
                                                        return (
                                                            <div className="col-6" key={tpl.id}>
                                                                <div
                                                                    onClick={() => this.toggleTemplate(tpl.id)}
                                                                    className={`d-flex align-items-center p-2 rounded-3 hand`}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        backgroundColor: isSelected ? 'rgba(99, 102, 241, 0.3)' : 'rgba(255,255,255,0.05)',
                                                                        border: isSelected ? '1px solid #818cf8' : '1px solid rgba(255,255,255,0.1)',
                                                                        transition: 'all 0.2s ease',
                                                                        color: '#e2e8f0'
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={isSelected}
                                                                        onChange={() => { }}
                                                                        style={{ accentColor: '#6366f1', marginLeft: '8px' }}
                                                                    />
                                                                    <span style={{ fontSize: '0.85rem' }}>{tpl.title}</span>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* بقیه فیلدها (مجری، سرپرست، اولویت، وضعیت، توضیحات) بدون تغییر */}
                                    <div className="col-md-6">
                                        <label className="form-label">مجری</label>
                                        <select className="form-select" value={record.assignedToUserId || ''}
                                            onChange={e => this.handleChange('assignedToUserId', e.target.value ? parseInt(e.target.value) : null)}>
                                            <option value="">-- انتخاب --</option>
                                            {users.map(u => <option key={u.id} value={u.id}>{u.fullName}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">سرپرست</label>
                                        <select className="form-select" value={record.supervisorUserId || ''}
                                            onChange={e => this.handleChange('supervisorUserId', e.target.value ? parseInt(e.target.value) : null)}>
                                            <option value="">-- انتخاب --</option>
                                            {users.map(u => <option key={u.id} value={u.id}>{u.fullName}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">اولویت</label>
                                        <select className="form-select" value={record.priority}
                                            onChange={e => this.handleChange('priority', parseInt(e.target.value))}>
                                            <option value="1">کم</option>
                                            <option value="2">متوسط</option>
                                            <option value="3">زیاد</option>
                                            <option value="4">حیاتی</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">وضعیت</label>
                                        <select className="form-select" value={record.status}
                                            onChange={e => this.handleChange('status', parseInt(e.target.value))}>
                                            <option value="1">جدید</option>
                                            <option value="2">در حال انجام</option>
                                            <option value="3">نیازمند مدارک</option>
                                            <option value="4">بررسی سرپرست</option>
                                            <option value="5">تکمیل شده</option>
                                        </select>
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">توضیحات</label>
                                        <textarea className="form-control" rows="3" value={record.description}
                                            onChange={e => this.handleChange('description', e.target.value)}></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary" disabled={lockScreen === 1}>
                                    {lockScreen === 1 && <span className="spinner-border spinner-border-sm"></span>} ذخیره
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={onClose}>انصراف</button>
                            </div>
                        </form>
                    </div>
                </div>
                {/* پورتال dropdown جستجوی قرارداد */}
                {contractDropdownOpen && createPortal(
                    <div
                        style={{
                            position: 'absolute',
                            top: dropdownPosition.top,
                            left: dropdownPosition.left,
                            width: dropdownPosition.width,
                            zIndex: 9999,
                            background: 'rgba(30, 41, 59, 0.98)',
                            backdropFilter: 'blur(16px)',
                            border: '1px solid rgba(255,255,255,0.2)',
                            borderRadius: '12px',
                            maxHeight: '250px',
                            overflowY: 'auto',
                            boxShadow: '0 10px 30px rgba(0,0,0,0.5)'
                        }}
                    >
                        <button type="button" className="dropdown-item text-muted"
                            onClick={() => {
                                this.handleChange('contractId', null);
                                this.setState({ contractSearchTerm: '', contractDropdownOpen: false });
                                this.handleChange('title', '');
                                this.handleChange('description', '');
                            }}
                            style={{ color: '#cbd5e1' }}>
                            -- حذف انتخاب --
                        </button>
                        {filteredContracts.map(c => (
                            <button key={c.id} type="button" className="dropdown-item"
                                style={{ color: '#e2e8f0', transition: '0.2s' }}
                                onClick={() => this.selectContract(c)}>
                                {c.title}
                            </button>
                        ))}
                        {filteredContracts.length === 0 && (
                            <div className="dropdown-item text-muted">موردی یافت نشد</div>
                        )}
                    </div>,
                    document.body
                )}
            </div>
        );
    }
}